import { ClientMessagesStatusEnum, ClientMessagesTypeEnum, SelectOption } from '@tassat/common-definitions';

import { emptySelectOption } from 'Lib/constant';

export const clientMessageTypeOptions: SelectOption[] = [
    emptySelectOption,
    {
        label: 'Advisory',
        value: ClientMessagesTypeEnum.ADVISORY
    },
    {
        label: 'Banner',
        value: ClientMessagesTypeEnum.BANNER
    }
];

export const clientMessageStatusOptions: SelectOption[] = [
    emptySelectOption,
    {
        label: 'Active',
        value: ClientMessagesStatusEnum.ACTIVE
    },
    {
        label: 'Canceled',
        value: ClientMessagesStatusEnum.CANCELLED
    },
    {
        label: 'Declined',
        value: ClientMessagesStatusEnum.DECLINED
    },
    {
        label: 'Ended',
        value: ClientMessagesStatusEnum.ENDED
    },
    {
        label: 'Pending',
        value: ClientMessagesStatusEnum.PENDING
    }
];

export const getMappedColumn = (column) => {
    switch (column) {
        case 'ClientMsgType':
            return 'Type';
        default:
            return column;
    }
};